import { render, staticRenderFns } from "./horizontalLayout.vue?vue&type=template&id=2e47e508&scoped=true&"
import script from "./horizontalLayout.vue?vue&type=script&lang=js&"
export * from "./horizontalLayout.vue?vue&type=script&lang=js&"
import style0 from "./horizontalLayout.vue?vue&type=style&index=0&id=2e47e508&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47e508",
  null
  
)

export default component.exports